module.exports = __webpack_public_path__ + "static/media/correctYes.1d1d54ec.mp3";